/* eslint-disable jira/filename-case */

import type {
	ExtensionContextsMapNew,
	AggExtension,
} from '@jira/forge__forge-ui-types/src/common/types/extension.tsx';
import type { ExtensionPointModule } from '@jira/forge__forge-ui-types/src/common/types/module.tsx';

export function toMappedExtensions<
	ModuleType extends ExtensionPointModule,
	Result = {
		[Key in ModuleType]: ExtensionContextsMapNew[Key][];
	},
>(requestedModules: ModuleType[], returnedExtensions: AggExtension[]): Result {
	const result = Object.fromEntries<AggExtension[]>(requestedModules.map((type) => [type, []]));

	const extensions = toModuleIdAsIdExtensions(returnedExtensions);

	extensions.forEach((extension) => {
		result[extension.type]?.push(extension);
	});
	// There is no better way to work this out and preserve a generic object response
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return result as Result;
}

// Each Forge module has a unique id, however it may be used in different contexts.
// In those contexts, some modules may be hidden depending on display conditions.
// In order for Relay to not pick up hidden extensions from the cache, we need to use a unique id for each context.
// This is done on the backend side by appending the hash to the module id.
// This fixes the Relay cache issue but on the client side we still want to operate on the original extension id since Forge depends on it.
// That's why we swap id with moduleId, which represents the original id; also as a fallback we strip the hash from the id just in case.
export function toModuleIdAsIdExtensions(extensions: AggExtension[]): AggExtension[] {
	return extensions.map(({ moduleId, ...rest }) => ({
		...rest,
		id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
		moduleId,
	}));
}
